import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Moment from 'react-moment';
import './HomeView.css';
import Nav from '../Nav/Nav.js'
import Button from '../../components/Button/Button.js'
import Alert from '../../components/Alert/Alert.js'

export default class HomeView extends Component {

constructor(props, context) {
    super(props, context);

    this.state = {
      modulesInit: [],
      modules: [],
      dataLoading: true,
      loadMore: '',
      allContentLoaded: false,
      searchResults: [],
      searchLoader: '',
      typing: '',
      query: '',
      userData: [],
      loggedIn: false,
      showAlert: false,
      alertText: '',
      alertState: '',
      alertType: 'positive',
      sortDirection: 'asc',
      moduleOffset: 0,
      moduleLimit: 20,
      apiUrl: ''
    }

    this.handleChange = this.handleChange.bind(this);
    this.submitSearch = this.submitSearch.bind(this)
    this.clearSearch = this.clearSearch.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);


  }


  componentDidMount(){

     if(localStorage.userData){

      setTimeout(()=>{
        this.setState({
          userData: JSON.parse(localStorage.userData),
          loggedIn: true

        })

        if(window.location.hostname === 'localhost')
        {
          this.setState({
            apiUrl: 'http://127.0.0.1:3030'
          })
        }else{
          this.setState({
            apiUrl: 'http://trainer.activepipe.com:3030'
          })
        }

        document.addEventListener('mousedown', this.handleClickOutside)
        this.getModules(this.state.moduleOffset);
      });

    }else{
      window.location.href = '/login'
    }


  }

  /*-------------------------------------
      GET MODULES
  -----------------------------------------*/

  getModules(){


    this.setState({
      loadMore: 'loading'
    })

    const url = this.state.apiUrl + '/getModules';

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(
      {
        limit: this.state.moduleLimit,
        offset: this.state.moduleOffset
      }),
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    })
    .then((response) => response.json())
    .then((responseJson) =>
    {

        // console.log(responseJson);

        this.setState({
          modulesInit:  this.state.modulesInit.concat(responseJson.modules),
          modules:  this.state.modules.concat(responseJson.modules),
          moduleOffset: this.state.moduleOffset + this.state.moduleLimit,
          dataLoading: false,
          loadMore: ''
        })

        if(responseJson.count.total <= this.state.modulesInit.length)
        {
          this.setState({
            allContentLoaded: true
          })
        }


    }).catch((error) => {

        this.alert('Something went wrong. Trying checking your connection or refreshing the page.','negative', 10000)
        console.log("Errror");
        console.error(error);
    });

  }

  /*---------------------------------------
      GO TO MODULE
  -----------------------------------------*/
  gotoModule( moduleId){
    console.log(moduleId);
    window.location.href = '/build/' + moduleId;
  }

  /*---------------------------------------
      DELETE MODULE
  -----------------------------------------*/
  deleteModule(index, myId){


    const url = this.state.apiUrl  + '/deleteModule';
    let confirmDelete = window.confirm("Are you 100% sure you want to delete this Module!? Some clients may still be using the link!")
    if (confirmDelete){
    fetch(url, {
      method: 'POST',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      },
      body: JSON.stringify(
      {
        id: myId,
        modified: this.state.userData.name,
        modifiedID: this.state.userData.id
      })
    })
    .then((response) => response.json())
    .then((responseJson) =>
    {
      this.state.modules.splice(index,1);
      this.setState({
        modules: this.state.modules
      })

    })
    .catch((error) => {
        console.log("Error");
        console.error(error);
    });
  }

  }


  /*---------------------------------------
      SEARCH & SORT MODULES
  -----------------------------------------*/

  handleChange(event) {

    this.setState({
      query: event.target.value
    });

    if(this.state.query.length >= 0){
      this.setState({
        typing: true,
      })
    }else{
      this.setState({
        typing: false,

      })
    }

  }

  submitSearch(event){

     event.preventDefault()

     if(this.state.query.length < 1){
       this.setState({
          searchLoader: '',
          searchResults: []
        })
       return
     }else{
       this.setState({
          searchLoader: 'inputLoading'
        })
     }

    const url = this.state.apiUrl  + '/searchModules';

    fetch(url, {
      method: 'POST',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      },
      body: JSON.stringify(
      {
        query: this.state.query
      })
    })
    .then((response) => response.json())
    .then((responseJson) =>
    {

      if(responseJson.length > 0){
           this.setState({
            searchLoader: '',
            searchResults: responseJson
          })
      }else{
          this.setState({
            searchLoader: '',
            searchResults: [{
              name: 'No results',
              id: ''
            }]
          })
      }

    })
    .catch((error) => {
        console.log("Error");
        console.error(error);
    });
  }



clearSearch(){
  this.setState({
    searchLoader: '',
    searchResults: [],
    query: '',
    typing: false
  })

  document.getElementById('searchInput').focus()
}

setWrapperRef(node) {
    this.wrapperRef = node;
}

handleClickOutside(event){
    if (this.wrapperRef && !this.wrapperRef.contains(event.target))
    {
      this.clearSearch()
    }
}


/*---------------------------------------
    SORT
-----------------------------------------*/
sortBy(field){


    if(this.state.sortDirection === 'asc')
    {
      this.setState({sortDirection: 'desc'})
    }else{
      this.setState({sortDirection: 'asc'})
    }

    function compareValues(key, order='asc') {
      return function(a, b) {
        if(!a.hasOwnProperty(key) ||
           !b.hasOwnProperty(key)) {
          return 0;
        }
        const varA = (typeof a[key] === 'string') ?
          a[key].toUpperCase() : a[key];
        const varB = (typeof b[key] === 'string') ?
          b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return (
          (order === 'desc') ?
          (comparison * -1) : comparison
        );
      };
    }

    this.state.modules.sort(compareValues(field, this.state.sortDirection));

    this.setState({
        modules: this.state.modules,
    })

}

/*---------------------------------------
    GET LINK
-----------------------------------------*/
copyLink(id){
  const str = 'http://trainer.activepipe.com/module/' + id;
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);

  this.alert('Link copied to clipboard','positive', 2000)

}


  /*---------------------------------------
    ALERT
  -----------------------------------------*/

  alert(message, type, holdTime){
    this.setState({
      alertText: message,
      alertState: 'alertAppear',
      alertType: type,
      showAlert: true
    })
    setTimeout(()=>{
      this.setState({
      alertState: ''
      })
    },holdTime)
  }

  /*---------------------------------------
      RENDER
  -----------------------------------------*/
  render() {

    return (
      <div className="App">
      {this.state.loggedIn ?
      <div>

      {this.state.dataLoading ?
        <div className={"loader"}></div>
      : null}

      <Alert
        text={this.state.alertText}
        visible={this.state.alertState}
        type={this.state.alertType}
      />

       <Nav />
        <div className={"homeHeader"}>
          <h1>Modules</h1>
            <div className={"rhs"}>
            <Button text="New Module" clickAction={()=>window.location.href= '/build'} buttonColor="green" buttonState="plusIcon"/>
             <form onSubmit={this.submitSearch}>

              <input type="text" value={this.state.query} id="searchInput" className={this.state.searchLoader} onChange={this.handleChange} placeholder="Search for Module"/>
             {this.state.searchResults.length > 0 ?
              <div className="searchResults" ref={this.setWrapperRef}>
              {
               this.state.searchResults.map((results, index) =>{
                  return(
                      <Link to={'/build/' + results.id } key={index}>{results.name}</Link>
                    )
                })
              }
              </div>
            : null}
            </form>
            </div>
            {this.state.typing ?
              <button className="clearSearch" onClick={()=> this.clearSearch()}><img src={"../assets/images/icons/cross.svg"} alt="Clear Search"/></button>
            : null}
         </div>

        <div className={"homeWrapper"}>
          <table>
            <thead>
              <tr>
                <th onClick={()=> this.sortBy('id')}>ID</th>
                <th onClick={()=> this.sortBy('name')}>Public Name</th>
                <th onClick={()=> this.sortBy('description')}>Internal Description</th>
                <th onClick={()=> this.sortBy('last_modified_by')}>Modified By</th>
                <th onClick={()=> this.sortBy('created_by')}>Created By</th>
                <th onClick={()=> this.sortBy('updated_at')}>Last Updated</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
          <tbody>
          {
              this.state.modules.map((module, index) =>{
                  return(
                        <tr key={index} id={module.id} className={"tableLink"} >
                          <td onClick={()=>this.gotoModule(module.id)} className={"smallCell"}>{module.id}</td>
                          <td onClick={()=>this.gotoModule(module.id)}>{module.name}</td>
                          {module.description ?
                          <td onClick={()=>this.gotoModule(module.id)}>{module.description.length > 60 ? module.description.substring(0, 60) +' ...' : module.description}</td>
                          :
                          <td onClick={()=>this.gotoModule(module.id)}></td>
                          }
                          <td onClick={()=>this.gotoModule(module.id)}>{module.last_modified_by}</td>
                          <td onClick={()=>this.gotoModule(module.id)}>{module.created_by}</td>
                          <td onClick={()=>this.gotoModule(module.id)} className={"mediumCell"}><Moment format="ddd DD MMM YYYY HH:mma">{module.updated_at}</Moment></td>
                          <td title="Preview" className={"smallCell tooltip"} data-tooltip="Preview"><Link to={'/module/' + module.id } target="preview"><img src={"../assets/images/icons/eye.svg"} alt="" /></Link></td>
                          <td title="Copy Link" className={"smallCell tooltip"} data-tooltip="Copy Link" onClick={()=>this.copyLink(module.id)}><img src={"../assets/images/icons/link.svg"} alt="" /></td>
                          <td title="Delete" className={"smallCell tooltip"} data-tooltip="Delete" onClick={()=>this.deleteModule(index, module.id)} ><img src={"../assets/images/icons/trash.svg"} alt="" /></td>
                        </tr>
                  )
              })
           }
           </tbody>
           </table>
           {!this.state.allContentLoaded ?
           <Button text="Load More" clickAction={()=> this.getModules()} buttonColor="" buttonState={"loaderButton " + this.state.loadMore}/>
           : null}
        </div>

        </div>
      : null}
      </div>

    );
  }

}


// WEBPACK FOOTER //
// ./src/views/HomeView/HomeView.js